<template>
    <div>
        <competition-write-link v-for="writeLayout in writeLayouts" :key="`competitionComp${writeLayout}`"
                           :writeLayout="writeLayout" :competitionData = "competitionData"></competition-write-link>
    </div>
</template>

<script>
import CompetitionWriteLink from "@/components/competition/CompetitionWriteLink";
import competitionUtil from "@/components/competition/competitionUtil";
import DeleteClass from "@/mixins/deleteClass";
import EventBus from "@/utils/event-bus";
import alertMixins from "@/mixins/alertMixins";
import util from "@/mixins/util";
export default {
    name: "CompetitionWriteComponent",
    mixins: [competitionUtil,alertMixins],
    components: {CompetitionWriteLink},
    provide() {
        return {
            competitionWriteSetData:this.setData
        }
    },
    inject: ['changeLoading'],
    props: {
        competitionType: {default: ''},
        competitionKey: {
            type: String,
            default: () => {
                return ''
            }
        },
    },
    data() {
        return {
            writeLayouts: [],
            getFunc: '',
            detailApiParamsSet: {},
            keyName: '',
            competitionData: {},
            deleteFunc: '',
            deleteApiParamSet: {},
            deleteSuccessType: 1,
            deleteErrorTypes: {},
            deleteClass: null,
        }
    },
    created() {
        this.initConfig();
        this.getCompetition();
        this.initTemplateConfig()
    },
    mounted() {
        EventBus.$on('deleteCompetition',this.deleteCompetition)
    },
    beforeDestroy() {
        EventBus.$off('deleteCompetition')
    },
    destroyed() {
    },
    computed: {},
    methods: {
        setData(type, value) {
            this[type] = value;
        },
        initConfig() {
            let configCompetition = this.returnCompetitionConfig(this.competitionType);
            this.getFunc = configCompetition.getFunc;
            this.detailApiParamsSet = configCompetition.detailApiParamsSet
            this.keyName = configCompetition.keyName
            this.deleteFunc = configCompetition.deleteFunc;
            this.deleteApiParamSet = configCompetition.deleteApiParamSet;
            this.deleteSuccessType = configCompetition.deleteSuccessType;
            this.deleteErrorTypes = configCompetition.deleteErrorTypes;
            this.deleteKayName = configCompetition.deleteKayName

            this.initDeleteClass();
        },
        initTemplateConfig() {
            let configCompetition = this.returnCompetitionConfig(this.competitionType);
            this.writeLayouts = configCompetition.writeLayouts;
        },
        initDeleteClass() {
            let options = {
                func: this.$api.$competition[this.deleteFunc],
                apiParamSet: this.deleteApiParamSet,
                keyName: this.deleteKayName,
                successType: this.deleteSuccessType,
                errorTypes: this.deleteErrorTypes,
                afterFunc: this.deleteAfterFunc,
            }
            this.deleteClass = new DeleteClass(options);
        },
        getCompetition() {
            let params = JSON.parse(JSON.stringify(this.detailApiParamsSet))
            params[this.keyName] = this.competitionKey
            try {
                this.$api.$competition[this.getFunc](params).then(res => res.Data.Result).then(res => {
                    if (res.Info.type !== 1) {
                        this.createAlert({
                            title: '',
                            content: '데이터를 불러올 수 없습니다.',
                            btnText: '확인',
                            hide: () => {
                                this.$router.back();
                            }
                        });
                        return;
                    }
                    this.competitionData = res.List[0]
                    this.setDeleteButton()
                })
            } catch (e) {
                console.log(e)
            }

        },
        setDeleteButton(){
            if(!util.isEmpty(this.competitionData)){
                EventBus.$emit('CompetitionVueSetData','competitionStatus',this.competitionData.c_status)
            }
        },
        deleteAfterFunc() {
            this.createAlert({
                content: '삭제되었습니다.',
                hide: () => {
                    this.$router.back()
                }
            })
        },
        runDelete(key) {
            this.deleteClass.runDelete(key);
        },
        deleteCompetition(){
            this.createConfirm({
                content : '정말 삭제하시겠습니까?',
                confirm:()=>{
                    this.runDelete(this.competitionKey)
                }
            })
        }
    },
    watch: {},
}
</script>

<style scoped>

</style>
